(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('CommunicationTopic', CommunicationTopic);

    CommunicationTopic.$inject = ['$resource'];

    function CommunicationTopic ($resource) {
        var resourceUrl =  'api/communication-topic/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryInclDeleted': {
                method: 'GET',
                isArray: true,
                params: {inclDeleted:true}
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getChannel': {
            	url:'api/channel',
                method: 'GET',
                isArray: true
            },
            'byAgence': {
                url: 'api/communication-topic/by-agence/:agenceId',
                method: 'GET',
                isArray: true
            },
            'update': { method:'PUT' }
        });
    }
})();
